import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import SharedFoldersArchiveList from './SharedFoldersArchiveList';

const SharedFoldersArchive = () => {
  return renderComponent(<SharedFoldersArchiveList />);
};

export default SharedFoldersArchive;
